import { century, equationOfTime, declination } from 'solar-calculator';
import { geoCircle } from 'd3-geo';

// Antipode (point on the opposite side of Earth from the sun) drives the
// night hemisphere — we draw a great-circle of radius 90° around it.
function antipode([lat, lon]) {
  return [-lat, lon > 0 ? lon - 180 : lon + 180];
}

// SubsolarPoint returns [lat, lon] of where the sun is overhead.
export function subsolarPoint(date = new Date()) {
  const t = century(date);
  const longitude = ((date.getUTCHours() + date.getUTCMinutes() / 60) * 15 - 180);
  const lon = longitude - equationOfTime(t) / 4;
  const lat = declination(t);
  return [lat, lon];
}

// NightPolygon — a GeoJSON polygon for the night hemisphere centred on the
// antipode of the sun. Renderable via d3-geo's path generator.
export function nightPolygon(date) {
  const sun = subsolarPoint(date);
  const anti = antipode(sun);
  return geoCircle().center([anti[1], anti[0]]).radius(90)();
}

// GraylinePolygon — annular band along the terminator (sun ±2° elevation).
// Rendered as the difference of two circles, but we return the outer band
// outline as a GeoJSON polygon to be drawn with a thicker stroke.
export function graylinePolygon(date, halfWidthDeg = 2) {
  const sun = subsolarPoint(date);
  const anti = antipode(sun);
  return geoCircle().center([anti[1], anti[0]]).radius(90 + halfWidthDeg)();
}

export function graylineInner(date, halfWidthDeg = 2) {
  const sun = subsolarPoint(date);
  const anti = antipode(sun);
  return geoCircle().center([anti[1], anti[0]]).radius(90 - halfWidthDeg)();
}
